// ** Redux Imports
import { createSlice, createAsyncThunk, isPending, isFulfilled, isRejected } from '@reduxjs/toolkit';
import CommonService from 'services/common';
// import ComModuleService from 'services/comModule'
import { getProduct, getProducts, getProject, handleAsyncCall } from 'utils/common';
import _ from 'lodash';
import { micService } from 'services/mic';
import userAdmin from 'menu-items/userAdmin';
import { userAdminService } from 'services/userAdmin';
import userAccess from 'services/userAccess';
import { sessionConfig } from 'utils/constant';

export const rFetchProjectList = createAsyncThunk('act/rFetchProjectList', async (params, { rejectWithValue }) => {
  const res = await handleAsyncCall({
    service: userAccess.getProjectList,
    rejectWithValue,
    successCb: params?.successCb
  });

  return res;
});
export const rFetchProductList = createAsyncThunk('act/rFetchProductList', async (params, { rejectWithValue }) => {
  const res = await handleAsyncCall({
    service: userAccess.getProductList,
    rejectWithValue
  });

  return res;
});

export const rFetchRoleList = createAsyncThunk('act/rFetchRoleList', async (params, { rejectWithValue }) => {
  const res = await handleAsyncCall({
    service: userAdminService.getRoleList,
    rejectWithValue
  });

  return res;
});

export const rFetchBcTypes = createAsyncThunk('act/rFetchBcTypes', async (params, { rejectWithValue }) => {
  const res = await handleAsyncCall({
    service: micService.getBcTypes,
    params: {
      projid: params?.projid
    },
    rejectWithValue
  });

  return res;
});

export const rFetchSteps = createAsyncThunk('act/rFetchSteps', async (params, { rejectWithValue, getState }) => {
  const projid = getState().auth.project.ProjId;
  const bctype = getState().comModule.bctype;

  const res = await handleAsyncCall({
    service: micService.getWorkflowSteps,
    params: {
      projid
    },
    rejectWithValue
  });

  return res;
});
export const rFetchWorkflows = createAsyncThunk('act/rFetchWorkflows', async (params, { rejectWithValue, getState }) => {
  // const projid = getState().auth.project.ProjId;
  const projid = '629F9E29-0B36-4A9E-A2C4-C28969285583';

  const res = await handleAsyncCall({
    service: micService.getWorkflowList,
    params: {
      projid
    },
    rejectWithValue
  });
  return res;
});

export const rFetchCategories = createAsyncThunk('act/rFetchCategories', async (params, { rejectWithValue, getState }) => {
  const projid = getState().auth.project.ProjId;

  const res = await handleAsyncCall({
    service: micService.getBcCategories,
    params: {
      projid
    },
    rejectWithValue
  });
  return res;
});
export const rFetchCompanies = createAsyncThunk('act/rFetchCompanies', async (type, { rejectWithValue, getState }) => {
  const projid = getState().auth.project.ProjId;

  const res = await handleAsyncCall({
    service: micService.getCompanies,
    params: { type, id: projid },
    rejectWithValue
  });
  return {
    type,
    res
  };
});

export const rFetchConcretes = createAsyncThunk('act/rFetchConcretes', async (params, { rejectWithValue, getState }) => {
  const projid = getState().auth.project.ProjId;

  const res = await handleAsyncCall({
    service: micService.getConcretes,
    params: projid,
    rejectWithValue
  });
  return res;
});

export const rFetchRegions = createAsyncThunk('act/rFetchRegions', async (params, { rejectWithValue, getState }) => {
  const projid = getState().auth.project.ProjId;

  const res = await handleAsyncCall({
    service: micService.getRegions,
    params: {
      projid
    },
    rejectWithValue
  });
  return res;
});

export const rFetchFloors = createAsyncThunk('act/rFetchFloors', async (params, { rejectWithValue, getState }) => {
  const projid = getState().auth.project.ProjId;

  const res = await handleAsyncCall({
    service: micService.getFloors,
    params: {
      projid,
      region: params.region
    },
    rejectWithValue
  });
  return res;
});

export const rFetchLocations = createAsyncThunk('act/rFetchLocations', async (params, { rejectWithValue, getState }) => {
  const projid = getState().auth.project.ProjId;

  const res = await handleAsyncCall({
    service: micService.getLocationList,
    params: {
      projid,
      region: params?.region,
      floor: params?.floor
    },
    rejectWithValue
  });
  return res;
});

// export const rFetchDetails = createAsyncThunk(
//     'act/rFetchDetails',
//     async (params, { rejectWithValue }) => {
//         const res = await handleAsyncCall({
//             service: ComModuleService.getDetails,
//             params,
//             rejectWithValue
//         })

//         return {
//             res,
//             cat: params.cat
//         }
//     }
// )

// export const rUpdateComModule = createAsyncThunk(
//     'act/rUpdateComModule',
//     async (props, { rejectWithValue }) => {
//         const res = await handleAsyncCall({
//             service: ComModuleService.putComModule,
//             rejectWithValue,
//             ...props
//         })

//         return res
//     }
// )
// export const rUpdateComModuleDetail = createAsyncThunk(
//     'act/rUpdateComModule',
//     async (props, { rejectWithValue }) => {
//         const res = await handleAsyncCall({
//             service: ComModuleService.putComModuleDetail,
//             ...props,
//             rejectWithValue
//         })

//         return res
//     }
// )

// export const rFetchEnquiryDetails = createAsyncThunk(
//     'act/rFetchEnquiryDetails',
//     async (params, { rejectWithValue, getState }) => {
//         const eCeilingDetailsId = getState().comModule.eCeilingDetailsId
//         const eDoorDetailsId = getState().comModule.eDoorDetailsId

//         const _params =
//             params.cat === ENQUIRY_CAT.DOOR ? eDoorDetailsId : eCeilingDetailsId

//         const res = await handleAsyncCall({
//             service: ComModuleService.getEnquiryDetails,
//             params: _params,
//             rejectWithValue
//         })

//         return {
//             res,
//             cat: params.cat
//         }
//     }
// )

export const ComModuleSlice = createSlice({
  name: 'comModule',
  initialState: {
    bctype: '',
    settingType: '',
    categories: [],
    subCategories: [],
    regions: [],
    floors: [],
    companies: [],
    concretes: [],
    workflows: [],
    locations: [],
    steps: [],
    bcTypes: [],
    roles: [],
    projects: [],
    products: getProducts() || [],
    product: getProduct() || {},
    userProjsRoles: [],
    selectedRegion: '',
    selectedFloor: '',
    selectedRoom: '',
    selectedData: [],
    savedFilterData: {},
    isLoading: false,
    error: ''
  },
  reducers: {
    handleDetailsChange: (state, action) => {
      const [id, value] = action.payload;
      state.details[id] = value;
    },
    setState: (state, action) => {
      const [key, value] = action.payload;
      state[key] = value;
    }
  },
  extraReducers: (builder) => {
    builder
      // .addCase(rFetchDetails.fulfilled, (state, action) => {
      //     const { res, cat } = action.payload

      //     if (cat === COMMODULE_CAT.DOOR_INSPECTION) {
      //         state.doorDetails = res
      //     }
      //     if (cat === COMMODULE_CAT.CEILING_INSPECTION) {
      //         state.ceilingDetails = res
      //     }
      //     if (cat === COMMODULE_CAT.ROOF_INSPECTION) {
      //         state.roofDetails = res
      //     }
      // })
      .addCase(rFetchCategories.fulfilled, (state, action) => {
        const data = action.payload;
        const mapData = data.map((d, index) => ({ Id: `bc-category-${index}`, ...d }));
        const filteredCategories = state?.bctype ? mapData.filter(({ Bctype }) => Bctype === state.bctype) : mapData;
        state.categories = filteredCategories.filter(({ IsSubcategory }) => !IsSubcategory);
        state.subCategories = filteredCategories.filter(({ IsSubcategory }) => !!IsSubcategory);
      })
      .addCase(rFetchProjectList.fulfilled, (state, action) => {
        const data = action.payload;
        state.projects = data;
      })
      .addCase(rFetchProductList.fulfilled, (state, action) => {
        const data = action.payload;

        localStorage.setItem(sessionConfig.products, JSON.stringify(data));

        state.products = data;
      })
      .addCase(rFetchRoleList.fulfilled, (state, action) => {
        const data = action.payload;
        state.roles = data;
      })
      .addCase(rFetchRegions.fulfilled, (state, action) => {
        const data = action.payload;
        state.regions = data;
      })
      .addCase(rFetchFloors.fulfilled, (state, action) => {
        const data = action.payload;
        state.floors = data;
      })
      .addCase(rFetchLocations.fulfilled, (state, action) => {
        const data = action.payload;
        state.locations = data;
      })
      .addCase(rFetchWorkflows.fulfilled, (state, action) => {
        const data = action.payload;
        state.workflows = data;
      })
      .addCase(rFetchCompanies.fulfilled, (state, action) => {
        const data = action.payload;
        if (data.type) {
          const cType = data.type.replace(/\s/g, '').toLowerCase();
          state[cType] = data.res;
          return;
        }
        state.companies = data.res;
      })
      .addCase(rFetchConcretes.fulfilled, (state, action) => {
        const data = action.payload;
        state.concretes = data;
      })
      .addCase(rFetchSteps.fulfilled, (state, action) => {
        const data = action.payload;
        state.steps = data;
      })
      .addCase(rFetchBcTypes.fulfilled, (state, action) => {
        const data = action.payload;
        state.bcTypes = data;
      })
      .addMatcher(isPending, (state) => {
        state.isLoading = true;
      })
      .addMatcher(isFulfilled, (state) => {
        state.isLoading = false;
      })
      .addMatcher(isRejected, (state, action) => {
        state.error = action.payload;
        state.isLoading = false;
      });
  }
});

export const getStoredSelectedData = (state) => state.comModule.selectedData;
export const getIsLoading = (state) => state.comModule.isLoading;

export const { handleDetailsChange, setState } = ComModuleSlice.actions;

export default ComModuleSlice.reducer;
